"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withQueryClient = void 0;
var _constants = require("../constants");
var _acsScWebPlatformApi = require("@adsk/acs-sc-web-platform-api");
var _queryClientUtils = require("../util/queryClientUtils");
const withQueryClient = function (queryClient) {
  let {
    invalidateByQueryKeys
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return requestFn => function (url, method, body) {
    let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    const {
      requestType,
      ...fetchOptions
    } = options;
    const isQuery = method === _constants.HttpMethod.Get || requestType === _constants.RequestType.Query;
    const requestFnWrapper = () => requestFn(url, method, body, options);
    if (!queryClient) {
      return requestFnWrapper();
    }
    if (!isQuery) {
      const queryKeysToInvalidate = invalidateByQueryKeys === null || invalidateByQueryKeys === void 0 ? void 0 : invalidateByQueryKeys(url, method);
      if (queryKeysToInvalidate) {
        if (queryKeysToInvalidate !== _queryClientUtils.NO_QUERIES_TO_INVALIDATE) {
          queryKeysToInvalidate.forEach(queryKeyToInvalidate => queryClient.removeQueries(queryKeyToInvalidate));
        }
      } else {
        const message = "Any API in acc-Issues sdk which defines mutation requests,\n          must define an invalidation function for affected queries (".concat(url, ")");
        const env = (0, _acsScWebPlatformApi.getEnv)();
        if (env !== _acsScWebPlatformApi.ENVS.PRODUCTION) {
          throw new Error(message);
        }
        console.error(message);
        queryClient.clear();
      }
      return requestFnWrapper();
    }
    const queryKey = (0, _queryClientUtils.getQueryKey)(url, body);
    return queryClient.fetchQuery(queryKey, requestFnWrapper, fetchOptions);
  };
};
exports.withQueryClient = withQueryClient;
//# sourceMappingURL=withQueryClient.js.map